import React from 'react'
import PropTypes from 'prop-types'

import {
  Paper,
  PaperHeadline,
  PaperContent,
  Text,
  Button,
  FormAction,
  Form,
  PageContent
} from '../..'
import { PetplaceLogo } from '../../../utils/svg-icons'

export class PetplaceRedirectCard extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    message: PropTypes.string,
    phoneNumber: PropTypes.string,
    logoutButtonProps: PropTypes.shape({
      id: PropTypes.string,
      onClick: PropTypes.func,
      disabled: PropTypes.bool
    }),
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  render() {
    const {
      id,
      className,
      style,
      refProp,
      logoutButtonProps,
      message
    } = this.props

    return (
      <PageContent className='ui-redirect-card-page'>
        <Paper
          id={id}
          className={className}
          style={style}
          ref={refProp}
          type={Paper.Types.clean}
        >
          <PaperContent className='ui-redirect-card'>
            <PetplaceLogo />
            <div className='spinner-border-md spinner-border' role='status'>
              <span class="sr-only">Loading...</span>
            </div>
            <Text type={Text.Types.headlineBold}>
              Sit & stay tuned! You’re being redirected to PetPlace.
            </Text>
            <Text type={Text.Types.body}>
              Your 24Petwatch microchip & membership details have transferred to PetPlace – your one-stop pet-parenting platform.
            </Text>
          </PaperContent>
        </Paper>
      </PageContent>
    )
  }
}
